import { render, staticRenderFns } from "./ItemOrderChangePopUp.vue?vue&type=template&id=9b3b98b6&scoped=true&"
import script from "./ItemOrderChangePopUp.vue?vue&type=script&lang=js&"
export * from "./ItemOrderChangePopUp.vue?vue&type=script&lang=js&"
import style0 from "./ItemOrderChangePopUp.vue?vue&type=style&index=0&id=9b3b98b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3b98b6",
  null
  
)

export default component.exports